import React from "react";
import { SearchBox as FluentUISearchBox } from "@fluentui/react/lib/SearchBox";
import { initializeIcons } from "@fluentui/react/lib/Icons";

initializeIcons();

interface SearchBoxProps {
  placeholder: string;
  onSearch: (newValue: string) => void;
  disabled?: boolean;
}

const SearchBox: React.FC<SearchBoxProps> = ({ placeholder, onSearch, disabled }) => {
  const [value, setValue] = React.useState<string>("");

  const handleChange = (
    event?: React.ChangeEvent<HTMLInputElement>,
    newValue?: string
  ) => {
    if (newValue !== undefined) {
      setValue(newValue);
    }
  };

  const handleSearch = (newValue?: string) => {
    onSearch(newValue ?? value);
  };

  return (
    <div className="search-box">
      <FluentUISearchBox
        placeholder={placeholder}
        onChange={handleChange}
        onSearch={handleSearch}
        value={value}
        disabled={disabled}
      />
    </div>
  );
};

export default SearchBox;






